import { push } from '@/common/utils';
import dataUtils from '@/common/dataUtils';
import dateUtils from '@/common/dateUtils';

export default {
  /**
   * Find out all track numbers (Kurse) which are involved within the current tour and return in the order of their occurrence.
   */
  concernedTrackNumbers(selectedTracks) {
    console.debug('Find out all track numbers of selectedTracks', JSON.stringify(selectedTracks, null, 2));
    let concernedTrackNumbers = {};
    selectedTracks.forEach((t, index) => {
      concernedTrackNumbers[t.kurs] = { track: t.kurs, index };
    });
    let sortedTrackNumbers = Object.keys(concernedTrackNumbers)
      .map((key) => concernedTrackNumbers[key].track)
      .sort();
    console.debug('sortedTrackNumbers', sortedTrackNumbers);
    return sortedTrackNumbers;
  },

  /**
   *
   * @param documents - the list of documents
   * @param selectedDate - a Date-Object which must be in between
   * @returns {*}
   */
  filterDocumentsByValidDate(documents, selectedDate) {
    if (selectedDate) {
      return documents.filter((f) => {
        return dateUtils.isBetweenIncludingEndDate(selectedDate, f.anzeige_von, f.anzeige_bis);
      });
    }
    return documents;
  },
  filterDocuments({
    fahrdienst452Files,
    filterByLineOrTrack = false,
    lines = [],
    tracks = [],
    selectedDate,
    fahrdienst452FileFilteringColumns = ['kurs', 'linie'],
  }) {
    console.debug(`filterDocuments with lines=${JSON.stringify(lines, null, 2)} tracks=${JSON.stringify(tracks, null, 2)}`);
    const filteredByDate = selectedDate ? this.filterDocumentsByValidDate(fahrdienst452Files, selectedDate) : fahrdienst452Files;

    let filteredByLineOrTrack = filterByLineOrTrack
      ? this.filterByTrackAndLine({
          fahrdienst452Files: filteredByDate,
          fahrdienst452FileFilteringColumns,
          lines,
          tracks,
        })
      : filteredByDate;
    return filteredByLineOrTrack;
  },

  /**
   * Filtering of files following rules:
   * - if lines AND tracks are given as filtering criteria, filter file.linie for lines and file.kurs for tracks
   * - if lines OR tracks are given, then filter file.line and file.kurs for lines or tracks
   * @param fahrdienst452Files{Array} - files from fahrdienst452
   * @param fahrdienst452FileFilteringColumns{Array} - define explicitly which columns should be filtered
   * @param lines{Array} - lines to filter for
   * @param tracks{Array}  - kurse=tracks to filter for
   * @returns {Array} - accepted files
   */
  filterByTrackAndLine({ fahrdienst452Files, fahrdienst452FileFilteringColumns, lines = [], tracks = [] }) {
    let filterCriteria = [];
    if (lines.length > 0) filterCriteria = lines;
    if (tracks.length > 0) filterCriteria = filterCriteria.concat(tracks);

    return fahrdienst452Files.filter((file) => {
      let accept = false;

      if (lines.length > 0 && tracks.length > 0) {
        // console.debug(`filterByTrackAndLine file.linie includes ${lines} `)
        accept = this.isFileAccepted(file, 'linie', lines);
        if (accept) return true;

        // console.debug(`filterByTrackAndLine file.kurs includes ${tracks}`)
        accept = this.isFileAccepted(file, 'kurs', tracks);
      } else {
        // console.debug(`filterByTrackAndLine file.linie or file.kurs includes ${filterCriteria}`)
        if (fahrdienst452FileFilteringColumns.includes('linie')) {
          accept = this.isFileAccepted(file, 'linie', filterCriteria);
          if (accept) return true;
        }

        if (fahrdienst452FileFilteringColumns.includes('kurs')) {
          accept = this.isFileAccepted(file, 'kurs', filterCriteria);
        }
      }
      return accept;
    });
  },
  isFileAccepted(file, filePropertyName, filterCriteria) {
    let accept = false;
    if (!file[filePropertyName]) {
      accept = false;
    } else {
      let itemsInFile = file[filePropertyName].split(',').map((item) => item.trim());
      let includedLines = filterCriteria.filter((l) => itemsInFile.includes(`${l}`));

      accept = includedLines.length > 0;
    }
    return accept;
  },

  /**
   * Constructs an object with keys being file.typeIdFk values and their value is an array of fahrdienst452Files
   * @param {*} documentSelectionType ALL_DOCUMENTS or RELATED_DOCUMENTS
   * @param {*} fahrdienst452Files Array of fahrdienst452 files
   * @param {*} selectedTracks Array of selected tracks
   * @returns
   */
  constructFilesByTypeIdMap(documentSelectionType, fahrdienst452Files, selectedTracks, listAttr = 'kurs') {
    console.debug('constructFilesByTypeIdMap', documentSelectionType, fahrdienst452Files.length, listAttr);
    const filesByTypeId = {};
    const unreadCountByTypeId = {};
    if (fahrdienst452Files) {
      if (documentSelectionType === 'ALL_DOCUMENTS') {
        fahrdienst452Files.forEach((f) => {
          push(filesByTypeId, f.typeIdFk, f);
        });
      } else if (documentSelectionType === 'RELATED_DOCUMENTS') {
        if (selectedTracks && selectedTracks.length > 0) {
          fahrdienst452Files.forEach((f) => {
            if (!f[listAttr]) return;
            //console.debug('filter f[listAttr].split()', f[listAttr].split(','), 'for selectedTracks', selectedTracks);
            let kursArray = f[listAttr].split(',');
            let finding = selectedTracks.find((t) => kursArray.indexOf(`${t}`) > -1);
            if (!finding) return;
            push(filesByTypeId, f.typeIdFk, f);
          });
        }
      }
      Object.keys(filesByTypeId).forEach((typeId) => {
        let count = countUnread(filesByTypeId[typeId]);
        unreadCountByTypeId[typeId] = count;
      });
    }
    return { unreadCountByTypeId, filesByTypeId };
  },
};

function countUnread(files) {
  return files.filter((file) => !file._userState || !file._userState.dateread).length;
}
